import { useTranslation } from 'react-i18next';
import { ConverterDataSetTableType } from './store/converter.types';

export type ConverterDatasetTableDescriptor = {
  id: ConverterDataSetTableType;
  title: string;
  shortTitle: string;
  // setFilter: (tableState: DataTableState<string>) => void;
  // entities: Set<ActualityEntityType>;
};

const useConverterDatasetTableTypes = (): Record<
  ConverterDataSetTableType,
  ConverterDatasetTableDescriptor
> => {
  const { t } = useTranslation('feed');

  // const setActivityMetricTableState = useSetRecoilState(
  //   actualityHeatmapTableDataState,
  // );
  // const setActivityFeedTableState = useSetRecoilState(
  //   actualityHqTableDataState,
  // );
  // const setJobsTableState = useSetRecoilState(actualityJobsTableDataState);

  return {
    locations: {
      id: 'locations',
      title: t`Locations`,
      shortTitle: t`Locations`,
    },

    bays: {
      id: 'bays',
      title: t`Bays`,
      shortTitle: t`Bays`,
    },

    spacers: {
      id: 'spacers',
      title: t`Spacers`,
      shortTitle: t`Spacers`,
    },
    aisles: {
      id: 'aisles',
      title: t`Aisles`,
      shortTitle: t`Aisles`,
    },
  };
};

export default useConverterDatasetTableTypes;
